import { Aggregations } from '../model/aggregations';
import { BildungsangebotPage } from '../model/bildungsangebot-page';
import { Kosten } from '../model/kosten';
import { Weiterbildungsart } from '../model/weiterbildungsarten';
import { testAngebot } from './angebot.data';

export const bildungsangebotRestData: BildungsangebotPage = {
  _embedded: {
    bildungsangebotDTOList: [
      { ...testAngebot, id: 1001 },
      { ...testAngebot, id: 1002 },
      { ...testAngebot, id: 1003 }
    ]
  },
  _links: {
    first: { href: '/pc/v1/bildungsangebot?ids=70336&re=BY&bg=false&page=0&size=20' },
    self: { href: '/pc/v1/bildungsangebot?ids=70336&re=BY&bg=false&page=0' },
    next: { href: '/pc/v1/bildungsangebot?ids=70336&re=BY&bg=false&page=1&size=20' },
    last: { href: '/pc/v1/bildungsangebot?ids=70336&re=BY&bg=false&page=2&size=20' }
  },
  page: { size: 20, totalElements: 48, totalPages: 3, number: 0 }
};
export const aggregations: Aggregations = {
  WEITERBILDUNGSART: {
    [Weiterbildungsart.BERUFLICHE_QUALIFIZIERUNG]: 54,
    [Weiterbildungsart.AUFSTIEGSWEITERBILDUNG]: 89,
    [Weiterbildungsart.REHA_ANGEBOTE]: 0,
    [Weiterbildungsart.UMSCHULUNG]: 55,
    [Weiterbildungsart.TEILQUALIFIZIERUNG]: 0,
    [Weiterbildungsart.BERUFSABSCHLUSS_NACHHOLEN]: 2
  },
  LERNFORMEN: { VORORT: { 101: 48 } },
  REGIONEN: { BAY: 48 },
  ANZAHL_AUSGEFILTERT: { COUNT: 10 },
  ANZAHL_ANGEBOTE_GESAMT: { COUNT: 1 },
  ANBIETER: { 1: { anzahlErgebnisse: 123, name: 'Comcave' } },
  BEGINNTERMIN: {},
  DAUER: {},
  UNTERRICHTSZEIT: { 1: 120, 2: 20 },
  KOSTEN: { [Kosten.BIS_500_EUR]: 55, [Kosten.UEBER_500_BIS_1000_EUR]: 45 },
  BARRIEREFREIHEIT: {},
  FOERDERART: {
    '1': { id: 'bw_1', name: 'förderung a', anzahl: 9 },
    '2': { id: 'bl_2', name: 'förderung b', anzahl: 31 }
  }
};
